'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import UserFollowingPublicRoom from '@/app/[locale]/(worlds)/profile/components/UserFollowingPublicRoom';
import LoadMoreButton from '@/components/LoadMoreButton';
import { useUAContext } from '@/context/UAContext';
import { usePagination } from '@/hooks/usePagination';
import { AuthenticatedCommunityIdentity, AuthenticatedFollowingWithRooms, AuthenticatedFollowingsWithRoomsResults, getAuthenticatedFollowingsWithRooms } from '@/services/community';
const FOLLOWINGS_FETCH_SIZE = 4;
type UserFollowingPublicRoomsProps = {
  followingsData: AuthenticatedFollowingsWithRoomsResults;
  identity: AuthenticatedCommunityIdentity;
};
export default function UserFollowingPublicRooms(t0) {
  const $ = _c(22);
  const {
    followingsData,
    identity
  } = t0;
  let t1;
  if ($[0] !== followingsData?.data) {
    t1 = followingsData?.data || [];
    $[0] = followingsData?.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const followings = t1 as AuthenticatedFollowingWithRooms[];
  const t2 = followingsData?.from ?? 0;
  const t3 = followingsData?.total ?? 0;
  const t4 = followingsData?.size ?? 0;
  let t5;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = {
      from: t2,
      total: t3,
      size: t4
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const pages = t5;
  const [lists, setLists] = useState(followings);
  const {
    totalVramKb
  } = useUAContext();
  const viewableLists = lists.filter(_temp);
  const nextStart = pages.from + pages.size;
  const {
    isLoading,
    onPaginateStart,
    onPaginateComplete,
    start: from,
    total
  } = usePagination(nextStart, pages.total);
  const enableLoadMore = total > FOLLOWINGS_FETCH_SIZE && from < total;
  let t6;
  if ($[6] !== from || $[7] !== identity || $[8] !== onPaginateComplete || $[9] !== onPaginateStart || $[10] !== total || $[11] !== totalVramKb) {
    t6 = async function handleLoadMore() {
      onPaginateStart();
      const response = await getAuthenticatedFollowingsWithRooms(identity, totalVramKb, from, FOLLOWINGS_FETCH_SIZE);
      if (response.size) {
        setLists(currentLists => [...currentLists, ...response.data]);
        onPaginateComplete(response.from + response.size, response.total);
      } else {
        onPaginateComplete(from, total);
      }
    };
    $[6] = from;
    $[7] = identity;
    $[8] = onPaginateComplete;
    $[9] = onPaginateStart;
    $[10] = total;
    $[11] = totalVramKb;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleLoadMore = t6;
  const t7 = "flex flex-col gap-6 md:gap-9";
  const t8 = "flex flex-col gap-10";
  const t9 = viewableLists.map(_temp2);
  let t10;
  if ($[13] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== enableLoadMore || $[16] !== handleLoadMore || $[17] !== isLoading) {
    t11 = enableLoadMore && <div className="flex flex-1 justify-center"><LoadMoreButton isLoading={isLoading} onClick={handleLoadMore} /></div>;
    $[15] = enableLoadMore;
    $[16] = handleLoadMore;
    $[17] = isLoading;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <section className={t7}>{t10}{t11}</section>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function _temp2(room) {
  return <UserFollowingPublicRoom key={`following-rooms-of-${room.preferredUsername}`} room={room} />;
}
function _temp(t0) {
  const {
    publicRooms
  } = t0;
  return publicRooms.length > 0;
}